import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';

export const Test = styled.div`
    padding-right: 20px;
`;

export const OfferLink = styled.a`
    text-decoration: underline;
    color: ${COLORS.middleGray};

    @media (max-width: ${breakPoints.mobile}) {
        color: rgba(0,0,0,.7);
    }
`;

export const Offer = styled.div`
    display: inline;
    ${FONTS.XXS};
    color: ${COLORS.middleGray};
    white-space: pre-wrap;

    @media (max-width: ${breakPoints.mobile}) {
        color: rgba(0,0,0,.7);
        white-space: normal;
    }
`;
